<template>
    <div id="app">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>
<script>
    export default {
        name: 'app',
        methods: {
            doOnOrientationChange: function () {
                let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                switch (window.orientation) {
                    case -90 || 90:
                        $("#app").css('width', width + "px");
                        break;
                    default:
                        $("#app").css('width', width + "px");
                        break;
                }
            }
        },
        mounted: function ($nextTick) {
//      $nextTick = $nextTick || this.$nextTick(function () {
//        $(window).resize(function () {
//          let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
//          $("#app").css('width', width + "px");
//        }).resize();
//      });
//             let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
//             $("#app").css('width', width + "px");
//             this.$nextTick(function () {
//                 $(window).resize(function () {
//                     let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
//                     $("#app").css('width', width + "px");
//                 }).resize();
//
//             });
            //window.addEventListener('orientationchange', this.doOnOrientationChange);

        }

    }

</script>

<style lang="scss">

    @import url("http://fast.fonts.net/t/1.css?apiType=css&projectid=f302ed1d-2c99-4669-993f-d29ef5fa7853");

    @font-face {
        font-family: "Frutiger LT W01_55 Roma1475738";
        src: url("../static/fonts/fe232554-5489-4874-bb45-bd966c8c5932.eot?#iefix");
        src: url("../static/fonts/fe232554-5489-4874-bb45-bd966c8c5932.eot?#iefix") format("eot"), url("../static/fonts/0811514e-6660-4043-92c1-23d0b8caaa2f.woff2") format("woff2"), url("../static/fonts/aeae8cac-ba4d-40d2-bbcf-936f2c7dcfe6.woff") format("woff"), url("../static/fonts/caedf2e6-fbef-4928-b08e-1f975981ae8d.ttf") format("truetype"), url("../static/fonts/7def0e34-f28d-434f-b2ec-472bde847115.svg#7def0e34-f28d-434f-b2ec-472bde847115") format("svg");
    }

    @font-face {
        font-family: "Frutiger LT W01_65 Bold1475746";
        src: url("../static/fonts/eb06b4c3-c0fd-4cd0-a9d9-a2954f6839a7.eot?#iefix");
        src: url("../static/fonts/eb06b4c3-c0fd-4cd0-a9d9-a2954f6839a7.eot?#iefix") format("eot"), url("../static/fonts/8c92eb68-ce37-4962-a9f4-5b47d336bd1c.woff2") format("woff2"), url("../static/fonts/9bdfdcac-bbd4-46a9-9280-056c9a4438a2.woff") format("woff"), url("../static/fonts/5dae3a6e-9b07-4c2f-aed2-1f5b8951261b.ttf") format("truetype"), url("../static/fonts/eae74276-dd78-47e4-9b27-dac81c3411ca.svg#eae74276-dd78-47e4-9b27-dac81c3411ca") format("svg");
    }

    @font-face {
        font-family: "Frutiger LT W01_77 Black Cond";
        src: url("../static/fonts/7eee79cd-0bdf-42f5-934b-ea0719e8f972.eot?#iefix");
        src: url("../static/fonts/7eee79cd-0bdf-42f5-934b-ea0719e8f972.eot?#iefix") format("eot"), url("../static/fonts/6d87ec2c-6ff9-4959-ae4b-ee78bf6766d9.woff2") format("woff2"), url("../static/fonts/64002fd1-78f6-4403-bbaa-af1af63a80d9.woff") format("woff"), url("../static/fonts/350bf429-b295-4652-8bbd-c991c333406b.ttf") format("truetype"), url("../static/fonts/ff49f3f1-422a-4c44-80e2-be8dc904d23d.svg#ff49f3f1-422a-4c44-80e2-be8dc904d23d") format("svg");
    }

    body {
        font-family: "Frutiger LT W01_55 Roma1475738", 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*color: #2c3e50;*/
    }

    h1 {
        font-family: "Frutiger LT W01_77 Black Cond", 'Avenir', Helvetica, Arial, sans-serif;
    }

    p {
        font-family: "Frutiger LT W01_55 Roma1475738", 'Avenir', Helvetica, Arial, sans-serif;
    }

    #app {
        overflow: hidden;
        -ms-overflow-style: none;
        position: relative;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// src/App.vue